import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/components/SEO";

const SUBHEAD =
  "The GoHub Optical Plug-In is live. 100+ brands, 17,000 SKUs, virtual try-on, and 12 labs across Europe and the US shipping direct to your customers. No inventory, no optical expertise required.";

export const Route = createFileRoute("/launch")({
  head: () =>
    buildHead({
      path: "/launch",
      title: "GoHub Optical Plug-In is live",
      description: SUBHEAD,
      links: [
        { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
        {
          rel: "stylesheet",
          href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Poppins:wght@400;500;600;700;800&display=swap",
        },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/LaunchPlugin")),
});
